import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { auth } from '../../firebase';
import { ACCOUNT } from '../../constants/routes';
import { resetRoles } from '../../store/roles/actions';
import { resetUsers } from '../../store/users/actions';
import { resetDashboardDatas } from '../../store/dashboardDatas/actions';
import { resetRenters } from '../../store/renters/actions';
import { resetBikes } from '../../store/bikes/actions';
import { resetRents } from '../../store/rents/actions';
import { resetSites } from '../../store/sites/actions';
import { ROLE_USER } from '../../constants/roles';

export class AccountMenuItems extends Component {
  state={
    role: ROLE_USER,
  };

  static getDerivedStateFromProps(props) {
    let newState = null;
    if (props.authUser && props.roles) {
      newState = { ...newState, role: props.roles[props.authUser.uid] };
    }
    return newState;
  }

  signOut = () => {
    this.props.resetBikes();
    this.props.resetRenters();
    this.props.resetDashboardDatas();
    this.props.resetRoles();
    this.props.resetUsers();
    this.props.resetRents();
    this.props.resetSites();
    auth.doSignOut();
  };

  render() {
    return (
      <div>
        <MenuItem component={Link} to={ACCOUNT}>
          <Typography variant="subtitle1" gutterBottom>
            Mon compte
          </Typography>
        </MenuItem>
        <MenuItem
          id="sign_out"
          onClick={this.signOut}>
          <Typography variant="subtitle1" gutterBottom>
            Se déconnecter
          </Typography>
        </MenuItem>
      </div>);
  }
}

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    roles: state.roles.content,
  };
}

export default connect(
  mapStateToProps,
  {
    resetRoles,
    resetUsers,
    resetDashboardDatas,
    resetRenters,
    resetBikes,
    resetRents,
    resetSites,
  },
)(AccountMenuItems);




// WEBPACK FOOTER //
// ./src/components/Menu/AccountMenuItems.jsx